/** 统一处理 Cookie */

import type { SystemVersionDTO } from "@repo/codegen/teashop-base-api"
import Cookies from "js-cookie"
import CacheKey from "@/constants/cacheKey"
import { advanceBusinessContextRevision } from "@/utils/businessContext/revision"

export const getToken = () => {
  return Cookies.get(CacheKey.TOKEN)
}
export const setToken = (token: string) => {
  // 退出浏览器后，继续保留cookie 30 天
  Cookies.set(CacheKey.TOKEN, token, { expires: 30 * 24 })
  advanceBusinessContextRevision()
}
export const getRefreshToken = () => {
  return Cookies.get(CacheKey.REFRESH_TOKEN)
}
export const setRefreshToken = (token: string) => {
  Cookies.set(CacheKey.REFRESH_TOKEN, token, { expires: 30 * 24 })
}
export const removeToken = () => {
  Cookies.remove(CacheKey.TOKEN)
  advanceBusinessContextRevision()
}
export const removeRefreshToken = () => {
  Cookies.remove(CacheKey.REFRESH_TOKEN)
}

export const getAppVersionCookie = () => {
  return Cookies.get(CacheKey.APP_VERSION)
}
export const getStableVersionCookie = () => {
  return Cookies.get(CacheKey.STABLE_VERSION)
}
export const restoreVersionCookies = (appVersion?: string, stableVersion?: string) => {
  if (appVersion === undefined) Cookies.remove(CacheKey.APP_VERSION)
  else Cookies.set(CacheKey.APP_VERSION, appVersion, { expires: 30 * 24 })
  if (stableVersion === undefined) Cookies.remove(CacheKey.STABLE_VERSION)
  else Cookies.set(CacheKey.STABLE_VERSION, stableVersion, { expires: 30 * 24 })
}
/**
 * 设置目标版本信息，以便最新的stable_version、app_version等信息对下次访问cdn时生效
 * 当前实际版本信息不能参考该信息！！
 * @param version 版本信息
 */
export const setCookieWithNextVersion = (version: SystemVersionDTO) => {
  const frontModuleVersion = version?.versionModuleRels?.find(rel => rel.moduleType === 4)
  Cookies.set(CacheKey.APP_VERSION, frontModuleVersion?.moduleVersion ?? '', { expires: 30 * 24 })
  if (version.systemVersion?.isLatest) {
    Cookies.set(CacheKey.STABLE_VERSION, frontModuleVersion?.moduleVersion ?? '', { expires: 30 * 24 })
  }
}
